import { useNavigationStore } from "@/stores/navigation";
import { useConfigStore, MessengerTheme } from "@/stores/config";
import { computed, ref, watch } from 'vue';
import CoreService from "@/services/core.service";
import ConversationService from "@/services/conversation.service";
import { Home, Mail, MessageSquare, Moon, Sun } from 'lucide-vue-next';
// import { Home, Info, Mail, MessageSquare } from 'lucide-vue-next';
import WhatsappIcon from '@/components/icons/WhatsappIcon.vue';
import { Views } from "@/types/ConfigTypes";
export default {
    name: 'Footer',
    components: {
        Home,
        // Info,
        Mail,
        MessageSquare,
        Moon,
        Sun,
        WhatsappIcon
    },
    props: {
        title: String,
        body: String
    },
    data() {
        return {};
    },
    setup() {
        let currentViewName = ref('');
        const viewClicked = (view) => {
            const viewType = view.type;
            // console.log(currentViewName.value, view.type)
            if (currentViewName.value === view.type)
                return;
            switch (viewType) {
                case Views.PAGE:
                case Views.HOME_SCREEN:
                    if (currentViewName.value === Views.PAGE)
                        return;
                    CoreService.push(Views.PAGE, { id: 'home' });
                    break;
                case Views.CONVERSATION:
                case Views.LAST_CONVERSATION:
                    if (currentViewName.value === Views.CONVERSATION)
                        return;
                    ConversationService.openLastOrStartNewConversation();
                    // CoreService.push(Views.CONVERSATION, {
                    //   id: ConversationService.getCurrentConversationId() || ConversationService.getLastConversationId()
                    // })
                    break;
                case Views.HELPCENTER:
                    CoreService.push(Views.HELPCENTER);
                    break;
                case Views.MAILFORM:
                    CoreService.push(Views.MAILFORM);
                    break;
                case Views.WHATSAPP:
                    CoreService.push(Views.WHATSAPP);
                    break;
            }
        };
        const whatsappNumber = computed(() => {
            return CoreService.getWhatsappPhoneNumber();
        });
        const getViews = computed(() => {
            return this.navStore.getViews;
        });
        const toggleTheme = () => {
            const newTheme = useConfigStore().currentTheme === MessengerTheme.LIGHT ? MessengerTheme.DARK : MessengerTheme.LIGHT;
            useConfigStore().setTheme(newTheme);
        };
        watch(() => CoreService.getCurrentViewName(), newValue => {
            currentViewName.value = newValue;
        });
        return {
            whatsappNumber,
            getViews,
            toggleTheme,
            viewClicked: viewClicked,
            navStore: useNavigationStore(),
            configStore: useConfigStore(),
            currentViewName,
            Views,
            MessengerTheme
        };
    }
};
